
@if (aggregationData; as aggs) {
  <div class="aggregation-container">
    @for (key of aggregationKeys; track key; let i = $index) {
      @if (aggs[key] && (aggs[key]['buckets']?.length > 0 || key === 'tags') ) {
        <div class="filter">
          @if (key !== 'tags') {
            <ng-template [ngTemplateOutlet]="bucketSelectionOptions" [ngTemplateOutletContext]="{ options: aggs[key]['buckets'], key: key }"></ng-template>
          }
          @if (key === 'tags') {
            <ng-template [ngTemplateOutlet]="tagsSelectionOptions" [ngTemplateOutletContext]="{ options: aggs[key], key: key }"></ng-template>
          }
        </div>
      }
    }
    @if (aggregationLength === 0) {
      <app-empty-page-message
        icon="search"
        [message]="'search_aggregations.no_results' | translate"
      ></app-empty-page-message>
    }
  </div>
}

<ng-template #bucketSelectionOptions let-options="options" let-key="key">
  <ng-container [formGroup]="form">
    <h4>{{ aggregationLabels[key] }}</h4>
    <mat-selection-list [formControlName]="key">
      @for (option of options; track option) {
        @if (option.key) {
          <mat-list-option
            [value]="option.key"
            [selected]="form.get(key)?.value?.includes(option.key)"
            >
            <span class="option-label">
              @if (key === 'range_of_development') {
                <span>{{ getRangeOfDevelopmentLabel(option.key) | doenkidsTranslate: translationPrefix + '.' + key }}</span>&nbsp;{{ ['duration', 'preparation'].includes(key) ? ('generic.minutes' | translate) + '&nbsp;' : '' }}
              }
              @if (key === 'activity_kind') {
                <span>{{option.key | doenkidsTranslate: translationPrefix + '.aggregation.' + key }}</span>&nbsp;{{ ['duration', 'preparation'].includes(key) ? ('generic.minutes' | translate) + '&nbsp;' : '' }}
              }
              @if (key !== 'range_of_development' && key !== 'activity_kind') {
                <span>{{option.key | doenkidsTranslate: translationPrefix + '.' + key }}</span>&nbsp;{{ ['duration', 'preparation'].includes(key) ? ('generic.minutes' | translate) + '&nbsp;' : '' }}
              }
              <span class="count">
                ({{option.doc_count}})
              </span>
            </span>
          </mat-list-option>
        }
      }
    </mat-selection-list>
  </ng-container>
</ng-template>

<ng-template #tagsSelectionOptions let-options="options" let-key="key">
  <ng-container [formGroup]="form">
    <h4>{{ key | doenkidsTranslate: translationPrefix + '.labels' }}</h4>
    <mat-selection-list [formControlName]="key">
      @if (options['ou']) {
        @for (option of options['ou']['tags']['buckets']  | truncate_array: (showAllTags$ | async) ? 9999 : 25; track option) {
          @if (option.key) {
            <mat-list-option
              [value]="option.key"
              [selected]="form.get(key)?.value?.includes(option.key)"
              >
              <span class="option-label pinned-tag-aggregation">
                <mat-icon>push_pin</mat-icon><span>{{ option.key | doenkidsTranslate: translationPrefix + '.' + key }}</span>&nbsp;
                <span class="count">
                  ({{option.doc_count}})
                </span>
              </span>
            </mat-list-option>
          }
        }
      }
      @if (options['dk']) {
        @for (option of options['dk']['tags']['buckets'] | truncate_array: (showAllTags$ | async) ? 9999 : 25; track option) {
          @if (option.key) {
            <mat-list-option
              [value]="option.key"
              [selected]="form.get(key)?.value?.includes(option.key)"
              >
              <span class="option-label">
                <span>{{ option.key | doenkidsTranslate: translationPrefix + '.' + key }}</span>&nbsp;
                <span class="count">
                  ({{option.doc_count}})
                </span>
              </span>
            </mat-list-option>
          }
        }
      }
    </mat-selection-list>
    @if (!(showAllTags$ | async)) {
      <button mat-flat-button color="primary" class="show-all-tags-button" (click)="showMoreTags()">{{ 'generic.show_all' | translate }}</button>
    }
  </ng-container>
</ng-template>
